import React, {useEffect} from "react";
import "./TitleEdit.css";
import { Button, Tooltip, Input } from "antd";
import { ApproveIcon, EditTitleIcon, ErrorIcon } from "../../../icons";

export const TitleEdit = ({name, updateDashboard,setUpdatedName}) => {

    const originalName = name;
    const [title, setTitle] = React.useState("");
    const [isHover, setIsHover] = React.useState(false);
    const [isEdit, setIsEdit] = React.useState(false);

    let isInvalid = false;

    useEffect(() => {
        if(name){
        setTitle(name);
        isInvalid = name.trim().length === 0;
        }
    },[name])

    const setTitleAndUpdateDashboard = (e) => {
        setTitle(e.target.value);
        setUpdatedName(e.target.value)
}

    return (
        <div
            className="title-edit"
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
        >
            {!isEdit && (
                <>
                    <h4>{title}</h4>
                    <span className="badge">draft</span>
                </>
            )}
            {!isEdit && isHover && (
                <Tooltip title="Edit">
                    <Button
                        type="text"
                        onClick={() => setIsEdit(true)}
                        icon={<EditTitleIcon />}
                    />
                </Tooltip>
            )}
            {isEdit && (
                <Input
                    placeholder="Enter Title"
                    suffix={
                        <Tooltip title={isInvalid ? "Error" : "Save"}>
                            {isInvalid ? (
                                <ErrorIcon />
                            ) : (
                                <Button
                                    ghost
                                    size="small"
                                    style={{ border: "none" }}
                                    onClick={() => {
                                        if (!isInvalid) {
                                            setIsEdit(false);
                                        }
                                    }}
                                >
                                    <ApproveIcon onClick={(e) => updateDashboard(e,originalName, title)} />
                                </Button>
                            )}
                        </Tooltip>
                    }
                    onChange={(e) => setTitleAndUpdateDashboard(e)}
                    value={title}
                />
            )}
        </div>
    );
};
